import { Accordion as AccordionComponent, RichText } from '@/ui';
import { prependToNonHttpsHrefs } from '@lib/server';

import { BlockBase, Wrapper } from './utils';

export function Accordion({
  params,
  id,
  ...data
}: {
  defaultOpen: boolean;
  items: { title: string; content: { content: 'string | TrustedHTML' } }[];
} & BlockBase) {
  return (
    <Wrapper id={id}>
      <AccordionComponent
        defaultOpen={data.defaultOpen}
        type={'multiple'}
        items={data.items.map((item) => {
          const content = params?.venue
            ? prependToNonHttpsHrefs(item.content?.content, `/${params.venuesPage}/${params.venue}`)
            : item.content?.content;

          return {
            title: item?.title,
            content: <RichText>{content}</RichText>,
          };
        })}
      />
    </Wrapper>
  );
}
